"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelOrdersView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const utils_1 = require("@obvio/utils");
const UserPanelSectionView_1 = require("./UserPanelSectionView");
const EmptyInfo_1 = require("../../EmptyInfo");
const StyledCard = (0, app_1.styled)(ui_1.Card) `
  background: #fbfbfb;
  border-radius: 0;
  min-width: 58rem;
`;
const OrderWrap = (0, app_1.styled)(ui_1.Grid) `
  padding: 0 ${(theme) => theme.spacing.small};
`;
const CellTitle = app_1.styled.span `
  font-weight: bold;
  font-size: 0.9375rem;
  color: #000000;
`;
const StandardCellTitle = app_1.styled.span `
  font-size: 0.8125rem;
  color: #000000;
`;
const StandardCellValue = app_1.styled.span `
  font-size: 0.8125rem;
  font-weight: 400;
  color: ${(theme) => theme.colors.gray};
`;
const DateCell = app_1.styled.span `
  font-size: 0.9375rem;
  color: ${(theme) => theme.colors.gray.semidark};
`;
const DetailsButton = (0, app_1.styled)(ui_1.Button) `
  width: 100%;
  height: 100%;
  background: ${(theme) => theme.colors.gray};
  color: #ffffff;
  border-radius: 0.875rem;
`;
function StandardCell({ title, value }) {
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(StandardCellTitle, { children: title }), (0, jsx_runtime_1.jsx)(StandardCellValue, { children: value })] })));
}
function TitleCell({ title, value }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(CellTitle, { children: title }), (0, jsx_runtime_1.jsxs)(DateCell, { children: [t('label.date'), ": ", value] })] })));
}
const StatusTag = (0, app_1.styled)(ui_1.Tag) `
  height: 1.625rem;
  padding: 0 ${(theme) => theme.spacing.small};
  border-radius: ${(theme) => theme.radius.small};
  color: white;
`;
const StyledStack = (0, app_1.styled)(ui_1.Stack) `
  @media ${app_1.mobile} {
    overflow: auto;
  }
`;
function UserPanelOrderView({ order }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(StyledCard, { children: (0, jsx_runtime_1.jsxs)(OrderWrap, Object.assign({ templateColumns: "25% 20% 15% 15% 25%" }, { children: [(0, jsx_runtime_1.jsx)(ui_1.GridItem, Object.assign({ noCenter: true }, { children: (0, jsx_runtime_1.jsx)(TitleCell, { title: t('store.orderWithNumber', {
                            orderNumber: order.number,
                        }), value: "10.02.2021, 14:06" }) })), (0, jsx_runtime_1.jsx)(ui_1.GridItem, { children: (0, jsx_runtime_1.jsx)(StatusTag, { children: order.status }) }), (0, jsx_runtime_1.jsx)(ui_1.GridItem, { children: (0, jsx_runtime_1.jsx)(StandardCell, { title: "Przedmioty", value: `${order.items} szt.` }) }), (0, jsx_runtime_1.jsx)(ui_1.GridItem, { children: (0, jsx_runtime_1.jsx)(StandardCell, { title: "Suma", value: (0, utils_1.formatPrice)(order.total) }) }), (0, jsx_runtime_1.jsx)(ui_1.GridItem, Object.assign({ noCenter: true }, { children: (0, jsx_runtime_1.jsx)(DetailsButton, Object.assign({ href: `/zamowienie/${order.secret}` }, { children: t('label.viewDetails') })) }))] })) }));
}
function UserPanelOrdersView({ orders, }) {
    const { t } = (0, app_1.useTranslation)();
    const hasOrders = orders.length > 0;
    return ((0, jsx_runtime_1.jsx)(UserPanelSectionView_1.UserPanelSectionView, Object.assign({ title: t('store.yourOrders') }, { children: hasOrders ? ((0, jsx_runtime_1.jsx)(StyledStack, Object.assign({ kind: "vertical" }, { children: orders.map((order) => ((0, jsx_runtime_1.jsx)(UserPanelOrderView, { order: order }, order.id))) }))) : ((0, jsx_runtime_1.jsx)(EmptyInfo_1.EmptyInfo.Margin, { children: (0, jsx_runtime_1.jsx)(EmptyInfo_1.EmptyInfo, { svg: svg_1.SvgShoppingCart, title: t('warning.noOrders'), description: "" }) })) })));
}
exports.UserPanelOrdersView = UserPanelOrdersView;
